module.exports = __webpack_public_path__ + "static/media/close.7e19f165.svg";